module.exports = __webpack_public_path__ + "static/media/get-logo2.8910c03c.png";